// extracted by mini-css-extract-plugin
export default {"PageListAccordionContainer":"PageListAccordion_PageListAccordionContainer__uP1zx"};